import React, { useState, useEffect} from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Cookies from 'js-cookie';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = Cookies.get('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set('cookieConsent', 'true', { expires: 365 });
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div style={{ position: 'fixed', bottom: 50, width: '100%', backgroundColor: 'rgba(0, 0, 0, 0.3)', color: '#fff', padding: '10px', textAlign: 'center' }}>
      <p><b>O Brasil Extremos respeita a sua privacidade.</b><br /> Este site utiliza cookies para melhorar a experiência do usuário. Você pode rejeitá-los clicando em "Não Aceito", porém, algumas funcionalidades do site podem não funcionar corretamente.</p>
      <button onClick={handleAccept} style={{ padding: '5px 15px', marginTop: '10px', backgroundColor: '#a8aca8', color: '#000', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '1em' }}>
        Concordo
      </button>
      <Link to="/AvisoLegal" style={{ color: 'inherit', textDecoration: 'none', fontStyle: 'italic', fontSize: '1em', marginLeft: '20px' }}>Saiba mais</Link>
      <button onClick={() => setShowBanner(false)} style={{ padding: '5px 15px', marginTop: '10px', marginLeft: '20px', backgroundColor: '#a8aca8', color: '#000', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '1em' }}>
        Discordo
      </button>
      
    </div>
  );
};

// Estilos básicos para demonstração
const styles = {
  banner: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#333',
    color: '#fff',
    padding: '15px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    zIndex: 1000,
  },
  link: {
    color: '#4db8ff',
    textDecoration: 'underline',
  },
  button: {
    backgroundColor: '#4db8ff',
    color: '#fff',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    cursor: 'pointer',
  }
};

export default CookieBanner;